// Model.js
// -----------------------
// @module Case
define("SuiteDB.SDBServiceHardwareItems.SDBServiceHardwareItems.Model", [
  "SCModel",
  "Singleton",
  "Utils",
  "underscore",
], function (SCModelComponent, Singleton, Utils, _) {
  "use strict";

  var SCModel = SCModelComponent.SCModel;

  function SDBServiceHardwareItemsModel(options) {
    SCModel.call(this);

    this.options = options;
    this.selectedServices = [];
    this.selectedHardware = [];

    this.urlRoot = function () {
      return Utils.getAbsoluteUrl(
        getExtensionAssetsPath("services/SDBServiceHardwareItems.Service.ss")
      );
    };
    this.getServicesFieldComparison = function (item, services) {
      var applicableServices = [];
      var groups = {};
      for (var i = 0; i < services.length; i++) {
        var service = services[i];
        var itemValue = item.extras[service.itemField];
        var numberValue = parseFloat(itemValue);
        var isNumber = !!(
          (numberValue || numberValue == 0) &&
          (itemValue || itemValue == 0)
        );
        if (isNumber) itemValue = numberValue;
        else itemValue = String(itemValue);

        var equalCheck = !!(itemValue == service.value);
        var lowerCheck = !!(itemValue < service.value);
        var higherCheck = !!(itemValue > service.value);

        if (!isNumber) {
          lowerCheck = false;
          higherCheck = false;
        }

        var fullCheck = false;
        switch (service.operator) {
          case "=":
            fullCheck = equalCheck;
            break;
          case "<":
            fullCheck = lowerCheck;
            break;
          case ">":
            fullCheck = higherCheck;
            break;
          case "!=":
            fullCheck = !equalCheck;
            break;
          case "<=":
            fullCheck = !!(lowerCheck || equalCheck);
            break;
          case ">=":
            fullCheck = !!(higherCheck || equalCheck);
            break;
          default:
            break;
        }

        if (service.group) {
          if (groups[service.group] === undefined)
            groups[service.group] = fullCheck;
          else groups[service.group] = !!(groups[service.group] && fullCheck);

          var alreadyAddedIndex = _.findIndex(
            applicableServices,
            function (suggestedService) {
              return suggestedService == service.serviceItem;
            }
          );
          if (alreadyAddedIndex != -1 && !groups[service.group])
            applicableServices.splice(alreadyAddedIndex, 1);
          else if (groups[service.group])
            applicableServices.push(service.serviceItem);
        } else if (fullCheck) applicableServices.push(service.serviceItem);
      }
      return _.uniq(applicableServices);
    };

    this.getServicesByItem = function (item, services) {
      var applicableServices = [];
      var itemId = String(item.internalid);
      for (var i = 0; i < services.length; i++) {
        var service = services[i];
        var applicableItems = service.applicableItems.match(/\d+/g);
        if (applicableItems.indexOf(itemId) != -1)
          applicableServices.push(service.serviceItem);
      }
      return _.uniq(applicableServices);
    };

    this.getHardwareGeneralApplication = function (item, hardwares) {
      var applicableHardware = [];
      for (var i = 0; i < hardwares.length; i++) {
        var hardware = hardwares[i];

        var itemClass = item.extras.class;
        if (!itemClass) continue;
        itemClass = itemClass.toLowerCase();

        if (itemClass.indexOf(hardware.itemType) != 0) continue;

        applicableHardware.push(hardware.hardwareItem);
      }
      return _.uniq(applicableHardware);
    };

    this.getHardwareVariation = function (item, hardwares, vehicle) {
      var applicableHardware = [];
      for (var i = 0; i < hardwares.length; i++) {
        var hardwareConfig = hardwares[i];
        var hardwareItem = this.hardwareMapper[hardwareConfig.hardwareItem];
        if (!hardwareItem) continue;

        var itemValue = parseFloat(item.extras[hardwareConfig.itemField]);
        var vehicleValue = parseFloat(vehicle[hardwareConfig.vehicleField]);
        var hardwareItemValue = parseFloat(
          hardwareItem[hardwareConfig.hardwareFieldForItem]
        );
        var hardwareVehicleValue = parseFloat(
          hardwareItem[hardwareConfig.hardwareFieldForVehicle]
        );
        var itemVariance = parseFloat(hardwareConfig.itemVariance);
        var vehicleVariance = parseFloat(hardwareConfig.vehicleVariance);
        var overallVariance = parseFloat(hardwareConfig.overallVariance);
        if (
          isNaN(itemValue) ||
          isNaN(vehicleValue) ||
          isNaN(hardwareItemValue) ||
          isNaN(hardwareVehicleValue) ||
          isNaN(itemVariance) ||
          isNaN(vehicleVariance) ||
          isNaN(overallVariance)
        )
          continue;

        var itemCalculatedVariance = +Math.abs(
          itemValue - hardwareItemValue
        ).toFixed(4);
        var vehicleCalculatedVariance = +Math.abs(
          vehicleValue - hardwareVehicleValue
        ).toFixed(4);
        var overallCalculatedVariance = +Math.abs(
          itemCalculatedVariance + vehicleCalculatedVariance
        ).toFixed(4);
        // itemCalculatedVariance = Math.abs(itemCalculatedVariance);
        // vehicleCalculatedVariance = Math.abs(vehicleCalculatedVariance);

        if (
          itemCalculatedVariance > itemVariance ||
          vehicleCalculatedVariance > vehicleVariance ||
          overallCalculatedVariance > overallVariance
        )
          continue;

        applicableHardware.push(hardwareConfig.hardwareItem);
      }
      return _.uniq(applicableHardware);
    };

    this.getRecommendations = function (items) {
      var model = this;
      if (!model.fetched) return [];
      //configuration used changes depending on shopping experience
      model.updateConfig();

      //get current subsidiary id
      var currentLocation = model.locations.getSelectedLocation();
      var locationId = "6";
      if (currentLocation) locationId = currentLocation.internalid;

      //remove services that do not apply to the current subsidiary
      model.nonMandatoryServices = model.verifySubsidiary(
        model.nonMandatoryServices,
        locationId
      );
      model.mandatoryServices = model.verifySubsidiary(
        model.mandatoryServices,
        locationId
      );
      model.servicesConfig.FieldComparison = model.verifySubsidiary(
        model.servicesConfig.FieldComparison,
        locationId
      );

      //get recommendations for all items on the cart
      var allRecommendations = [];
      model.selectedServices = [];
      model.selectedHardware = [];
      _.each(items, function (item) {
        if (!item.extras) item.extras = item;
        var serviceRecommendationsForItem =
          model.getServiceRecommendations(item);
        var hardwareRecommendationsForItem = model.getHardwareSuggestions(item);
        allRecommendations.push({
          item: {
            display: item.displayname,
            id: item.internalid,
            groupValue:
              item.extras.custitemrs_tire_inside_diameter ||
              item.extras.custitemrs_wheel_diameter_min,
            class: item.extras.class,
          },
          services: serviceRecommendationsForItem,
          hardware: hardwareRecommendationsForItem,
        });
      });

      return allRecommendations;
    };

    this.getServiceRecommendations = function (item) {
      var model = this;
      var allRecommendations = [];
      //call functions to get applicable services for the item
      var servicesByItem = model.getServicesByItem(
        item,
        model.nonMandatoryServices
      );
      var mandatoryServices = model.getServicesByItem(
        item,
        model.mandatoryServices
      );
      var servicesFieldComparison = model.getServicesFieldComparison(
        item,
        model.servicesConfig.FieldComparison
      );
      var allServiceRecommendationsForItem = []
        .concat(servicesByItem)
        .concat(servicesFieldComparison);
      _.each(allServiceRecommendationsForItem, function (service) {
        var recommendedService = _.clone(
          model.serviceItems[service].serviceItem
        );
        recommendedService.quantity =
          (recommendedService.class &&
            /\b(ALIGNMENTS?)\b/i.test(
              recommendedService.class.toUpperCase()
            )) ||
          /\b(ALIGNMENT?)\b/i.test(recommendedService.display.toUpperCase())
            ? Math.ceil(item.quantity / 4)
            : item.quantity;
        allRecommendations.push(recommendedService);
      });
      //mandatory services are always added
      _.each(mandatoryServices, function (service) {
        model.addSelection({
          item: [item.internalid],
          id: service,
          quantity: item.quantity,
          mandatory: true,
        });
      });
      return _.uniq(allRecommendations, function (recommendation) {
        return recommendation.id;
      });
    };

    this.addSelectedItems = function (list) {
      var model = this;
      if (!model[list].length) return [];
      var linesToAdd = [];
      var itemsAdded = {};
      _.each(model[list], function (line) {
        if (!line.mandatory) {
          linesToAdd.push({
            item: {
              internalid: line.id,
            },
            quantity: line.quantity,
          });
          itemsAdded[line.id] = true;
        }
      });
      if (model.itemIds)
        _.each(model.itemIds, function (item) {
          itemsAdded[item] = true;
        });
      model[list] = _.reject(model[list], function (service) {
        return itemsAdded[service.id];
      });
      if (model.itemIds)
        linesToAdd = _.reject(linesToAdd, function (line) {
          return _.contains(model.itemIds, Number(line.item.internalid));
        });
      return linesToAdd;
    };

    this.updateCart = function () {
      var services = this.addSelectedItems("selectedServices");
      var hardware = this.addSelectedItems("selectedHardware");
      if (services.length || hardware.length)
        this.cart.addLines({
          lines: services.concat(hardware),
        });
    };

    this.verifySubsidiary = function (recommendations, subsidiary) {
      var model = this;
      return _.filter(recommendations, function (recommendation) {
        if (!model.serviceItems[recommendation.serviceItem]) return false;

        var subsidiaries =
          model.serviceItems[recommendation.serviceItem].serviceItem
            .subsidiaries;
        if (!subsidiaries) return true;

        if (!_.contains(subsidiaries, subsidiary)) return false;

        return true;
      });
    };

    this.getHardwareSuggestions = function (item) {
      var recommendedHardware = [];
      var allHardware = [];
      var model = this;
      //call functions to get applicable hardware items
      var generalHardware = model.getHardwareGeneralApplication(
        item,
        model.hardwareConfig.GeneralApplication
      );
      allHardware = allHardware.concat(generalHardware);
      if (this.vehicleInfo) {
        var variationHardware = model.getHardwareVariation(
          item,
          model.hardwareConfig.VehicleAndItemComparison,
          this.vehicleInfo
        );
        allHardware = allHardware.concat(variationHardware);
      }

      //set information for the hardware recommendations
      _.each(allHardware, function (recommendation) {
        var hardwareItem = model.hardwareMapper[recommendation];
        if (!hardwareItem) return;
        var recommendedHardwareItem = _.clone(hardwareItem);
        recommendedHardwareItem.quantity =
          (recommendedHardwareItem.class &&
            /\b(HUBCENTRIC RINGS?|LUG BOLTS?|LUG NUTS?)\b/i.test(
              recommendedHardwareItem.class.toUpperCase()
            )) ||
          /\b(HUB CENTRIC RINGS?|HUB CENTERING RINGS?|LUG BOLTS?|LUG NUTS?)\b/i.test(
            recommendedHardwareItem.display.toUpperCase()
          )
            ? Math.ceil(item.quantity / 4)
            : item.quantity;
        recommendedHardware.push(recommendedHardwareItem);
      });
      return _.uniq(recommendedHardware, function (recommendation) {
        return recommendation.id;
      });
    };

    this.updateVehicle = function () {
      //load selected vehicle
      var cookies = document.cookie.split(";");
      if (cookies && cookies.length > 1) {
        var selectedvehicle = cookies.find(function (cookie) {
          return cookie.indexOf("vehicleConfig=") !== -1;
        });
      }
      if (selectedvehicle) {
        this.selectedVehicle = selectedvehicle.split("=")[1].trim();
      } else {
        delete this.selectedVehicle;
      }

      //get vehicle information from script
      delete this.vehicleInfo;
      var self = this;
      if (this.selectedVehicle)
        this.fetch({
          data: {
            vehicleId: this.selectedVehicle,
            requestType: "vehicle",
          },
          async: false,
        }).done(function (res) {
          if (!res.error) {
            self.vehicleInfo = res;
          }
        });
    };

    this.addSelection = function (selection) {
      var model = this;

      if (selection.isHardware) {
        delete selection.isHardware;
        var selectionIndex = _.findIndex(
          model.selectedHardware,
          function (value) {
            var itemsMatch = true;
            if (value.item && value.item[0] != selection.item[0])
              itemsMatch = false;
            return value.id == Number(selection.id) && itemsMatch;
          }
        );
        if (selectionIndex == -1) model.selectedHardware.push(selection);
        else model.selectedHardware[selectionIndex] = selection;
        return;
      }

      delete selection.isHardware;
      var selectionItemSet = selection.item.sort().join("-");
      var selectionIndex = _.findIndex(
        model.selectedServices,
        function (value) {
          var selectedItemSet = value.item.sort().join("-");
          var itemOrServiceAdded = true;
          if (selection.forItem) itemOrServiceAdded = value.forItem;
          return (
            value.id == selection.id &&
            selectionItemSet == selectedItemSet &&
            itemOrServiceAdded
          );
        }
      );
      if (selectionIndex != -1)
        model.selectedServices[selectionIndex] = selection;
      else model.selectedServices.push(selection);

      return;
    };

    this.removeSelection = function (selection) {
      var model = this;

      if (selection.isHardware) {
        var selectionIndex = _.findIndex(
          model.selectedHardware,
          function (value) {
            var itemsMatch = true;
            if (value.item && value.item[0] != selection.item[0])
              itemsMatch = false;
            return value.id == Number(selection.id) && itemsMatch;
          }
        );
        if (selectionIndex == -1) return;
        model.selectedHardware.splice(selectionIndex, 1);
        return;
      }

      var selectionItemSet = selection.item.sort().join("-");
      var selectionIndex = _.findIndex(
        model.selectedServices,
        function (value) {
          var selectedItemSet = value.item.sort().join("-");
          return (
            value.id == selection.id && selectionItemSet == selectedItemSet
          );
        }
      );
      if (selectionIndex == -1) return;
      model.selectedServices.splice(selectionIndex, 1);

      return;
    };

    this.updateState = function () {
      var model = this;
      var locationSelected = model.locations.getSelectedLocation();
      if (locationSelected) {
        model.state = locationSelected.addrFields.state;
        return;
      }
      model.state = "AB";
      if (Utils.isInShopping()) return;
      var addressId = model.liveOrder.get("shipaddress");
      var addresses = JSON.parse(
        JSON.stringify(
          model.profile.get("addressbook") || model.profile.get("addresses")
        )
      );
      if (!addressId || !addresses.length) return;

      _.find(addresses, function (addrs) {
        if (addrs.internalid == addressId) {
          model.state = addrs.state;
        }
      });
      if (!model.state) model.state = "AB";
    };

    this.manageSummaryServices = function () {
      var model = this;
      var itemsToDisplay = [];
      var servicesForItem = [];
      _.each(model.selectedServices, function (service) {
        if (service.item.length === 1) servicesForItem.push(service);
      });

      var itemsMapper = model.get("itemMapper");
      var itemsWithServices = {};
      _.each(servicesForItem, function (service) {
        var item = itemsMapper[Number(service.item[0])];
        if (!item) return;
        var itemWithServices = {
          item: {
            id: item.internalid,
            display: item.displayname,
          },
          services: [],
        };
        if (itemsWithServices[item.internalid])
          itemWithServices = itemsWithServices[item.internalid];
        var price = Number(model.serviceItems[service.id].serviceItem.price);
        var taxRate = Number(
          model.serviceItems[service.id].tax[model.state].rate
        );

        var unitCost = price + price * (taxRate / 100);
        var cost = unitCost * service.quantity;
        itemWithServices.services.push({
          id: service.id,
          display: model.serviceItems[service.id].serviceItem.display,
          cost: Utils.formatCurrency(cost),
          rawCost: cost,
          notRemovable: !!service.mandatory || !Utils.isInShopping(),
          quantity: service.quantity,
        });
        itemsWithServices[item.internalid] = itemWithServices;
      });
      _.each(itemsWithServices, function (itemWithServices) {
        itemsToDisplay.push(itemWithServices);
      });
      model.summaryServices = itemsToDisplay;
    };

    this.updateOrderTotal = function () {
      var model = this;
      //update order total to include service item costs
      var totalCharge = 0;
      _.each(model.summaryServices, function (itemWithService) {
        totalCharge += _.reduce(
          itemWithService.services,
          function (acc, service) {
            acc += service.rawCost;
            return acc;
          },
          0
        );
      });
      if (!model.liveOrder.get("summary")) return 0;
      var orderTotal = model.liveOrder.get("summary").total;
      var otherCharges = model.externalVendor.get("otherCharges") || 0;
      var shippingCost = 0;
      if (Utils.isInShopping())
        shippingCost =
          model.liveOrder.attributes.summary.shippingcost ||
          model.liveOrder.attributes.summary.estimatedshipping;
      var newOrderTotal =
        totalCharge + orderTotal + otherCharges - shippingCost;
      model.externalVendor.set("serviceCharges", totalCharge);
      var totalElement = document.querySelector(".cart-summary-amount-total");
      if (!totalElement) {
        totalElement = document.querySelector(
          ".order-wizard-cart-summary-total"
        );
        if (totalElement)
          totalElement = totalElement.querySelector(
            ".order-wizard-cart-summary-grid-right"
          );
      }
      if (totalElement && orderTotal)
        totalElement.innerHTML = Utils.formatCurrency(newOrderTotal);
      return newOrderTotal || 0;
    };

    this.updateConfig = function () {
      var model = this;
      var experience = model.locations.getShoppingExperience();
      var location = model.locations.getSelectedLocation();
      if (experience == "instore" && location) {
        model.servicesConfig = _.clone(model.servicesConfigInStore);
        model.hardwareConfig = _.clone(model.hardwareConfigInStore);
      } else {
        model.servicesConfig = _.clone(model.servicesConfigOnline);
        model.hardwareConfig = _.clone(model.hardwareConfigOnline);
      }
      //separate the byitem services by whether they are mandatory or not
      model.nonMandatoryServices = [];
      model.mandatoryServices = [];
      _.each(model.servicesConfig.ByItem, function (element) {
        if (element.mandatory) model.mandatoryServices.push(element);
        else model.nonMandatoryServices.push(element);
      });
    };

    this.removeAddedRecommendations = function (recommendations) {
      var itemMapper = this.get("itemMapper");
      return _.filter(recommendations, function (recommendation) {
        recommendation.services = _.reject(
          recommendation.services,
          function (service) {
            return itemMapper[service.id];
          }
        );
        recommendation.hardware = _.reject(
          recommendation.hardware,
          function (hardware) {
            return itemMapper[hardware.id];
          }
        );

        if (_.isArray(recommendation.item))
          recommendation.itemSet = _.pluck(recommendation.item, "id").join("-");
        else recommendation.itemSet = String(recommendation.item.id);
        return (
          recommendation.services.length > 0 ||
          recommendation.hardware.length > 0
        );
      });
    };

    this.setCustomFields = function () {
      var LiveOrder = this.liveOrder;
      if (!LiveOrder.get("options")) return;
      //check if there is a placeholder item to set a custom body based on it
      var itemModels = LiveOrder.get("lines").models;
      var hasPlaceholder;
      _.each(itemModels, function (model) {
        if (hasPlaceholder) return;
        hasPlaceholder = model
          .get("item")
          .get("custitem_sdb_is_placeholder_item");
      });
      if (hasPlaceholder)
        LiveOrder.get("options")["custbody_sdb_has_hardware_items"] = "T";
      else LiveOrder.get("options")["custbody_sdb_has_hardware_items"] = "F";

      //set custom body for the service information
      var serviceItemsInformation = this.selectedServices;
      if (!serviceItemsInformation) {
        LiveOrder.get("options")["custbody_sdb_service_items_data"] = "[]";
        return;
      }

      var formattedServices = _.reduce(
        serviceItemsInformation,
        function (result, value) {
          var existing = _.findWhere(result, { id: value.id });
          if (existing) {
            existing.quantity += value.quantity;
          } else {
            result.push({ id: value.id, quantity: value.quantity });
          }
          return result;
        },
        []
      );

      LiveOrder.get("options")["custbody_sdb_service_items_data"] =
        JSON.stringify(formattedServices);
    };

    this.groupSuggestions = function (allRecommendations) {
      var model = this;
      //put recommendations based on a service under the item the service is recommended from
      var serviceRecommendations = {};
      _.each(allRecommendations, function (recommendation, index) {
        if (!model.serviceItems[recommendation.item.id]) return;
        recommendation.index = index;
        serviceRecommendations[recommendation.item.id] = recommendation;
      });
      allRecommendations = _.filter(
        allRecommendations,
        function (recommendation) {
          return !serviceRecommendations[recommendation.item.id];
        }
      );
      _.each(allRecommendations, function (recommendation) {
        var servicesToRemove = [];
        _.each(recommendation.services, function (service) {
          if (serviceRecommendations[service.id])
            servicesToRemove.push(service);
        });
        recommendation.services = _.difference(
          recommendation.services,
          servicesToRemove
        );
        _.each(servicesToRemove, function (service) {
          recommendation.services = recommendation.services.concat(
            serviceRecommendations[service.id].services
          );
        });
      });
      return allRecommendations;
    };

    this.removeInvalidServices = function () {
      var model = this;
      var items = this.get("items");
      var recommendations = this.suggestions;
      var serviceMapper = {};
      var itemsToRemove = [];

      _.each(recommendations, function (recommendation) {
        _.each(recommendation.services, function (service) {
          serviceMapper[service.id] = true;
        });
      });

      _.each(items, function (item) {
        if (
          model.serviceItems[item.internalid] &&
          !serviceMapper[item.internalid]
        )
          itemsToRemove.push(item);
      });

      if (!itemsToRemove.length) return;
      model.removingItems = true;

      model.cart
        .getLines()
        .then(function (lines) {
          var linesToRemove = [];
          _.each(itemsToRemove, function (item) {
            var line = _.find(lines, function (line) {
              return line.item.internalid === item.internalid;
            });
            linesToRemove.push(line);
          });
          for (var i = 0; i < linesToRemove.length; i++) {
            model.cart.removeLine({
              line_id: linesToRemove[i].internalid,
            });
          }
        })
        .then(function () {
          model.removingItems = false;
        });
    };
  }

  SDBServiceHardwareItemsModel.prototype = Object.create(SCModel.prototype);
  SDBServiceHardwareItemsModel.prototype.constructor =
    SDBServiceHardwareItemsModel;

  return _.extend(SDBServiceHardwareItemsModel, Singleton);
});
